import { ThemingConfig } from '@chakra-ui/react';

import recipes from './basic';
import slotRecipes from './slotted';

export const themeRecipes: ThemingConfig = {
  recipes,
  slotRecipes,
};
